export default "__VITE_ASSET__Wa69CCbu__"